import { clsx } from 'clsx';
import Icon from '../Icon/Icon';
import SvgIcon from '../SvgIcon/SvgIcon';
import { isSvgIcon } from '../utils/svg';
import type { SeeqActionDropdownItems } from './SeeqActionDropdown.types';

export const SeeqActionDropdownItem = (item: SeeqActionDropdownItems) => {
  let renderIcon = <></>;
  if (item.icon) {
    renderIcon = isSvgIcon(item.icon) ? (
      <SvgIcon
        icon={item.icon}
        extraClassNames={`${item.iconExtraClassNames}tw:p-1 tw:h-9 tw:w-9 tw:dark:text-sq-white tw:text-5.5! tw:text-sq-white`}
        {...item}
      />
    ) : (
      <Icon
        icon={item.icon}
        type="text"
        extraClassNames={`tw:dark:text-sq-white tw:text-5.5! tw:text-sq-white tw:min-w-9 ${item.iconExtraClassNames}`}
      />
    );
  }

  return (
    <div className="tw:flex tw:w-150 tw:flex-row tw:gap-4 tw:p-2.5 tw:pl-5">
      <div
        className={clsx(
          'tw:flex tw:h-9 tw:w-9 tw:items-center tw:justify-center tw:rounded-[0.1875rem] tw:bg-sq-theme-dark' +
            ' tw:mt-1.5',
          item.iconContainerExtraClassNames,
        )}>
        {renderIcon}
      </div>
      <div className="tw:flex tw:flex-col tw:justify-center">
        <div className="tw:text-[20px] tw:font-semibold">{item.display}</div>
        <div className="tw:text-sq-13 tw:leading-4">{item.text}</div>
      </div>
    </div>
  );
};

export const ViewWorkbench = (item: SeeqActionDropdownItems) => {
  let renderIcon = <></>;
  if (item.icon) {
    renderIcon = isSvgIcon(item.icon) ? (
      <SvgIcon
        icon={item.icon}
        extraClassNames={`tw:w-4 tw:text-5 tw:dark:text-sq-white tw:text-sq-text-color ${item.iconExtraClassNames}`}
        type="default"
        {...item}
      />
    ) : (
      <Icon
        icon={item.icon}
        type="text"
        extraClassNames={`tw:text-5 tw:dark:text-sq-white tw:text-sq-text-color ${item.iconExtraClassNames}`}
      />
    );
  }

  return (
    <div className="tw:flex tw:flex-col tw:p-2.5">
      <div className="tw:flex tw:flex-row tw:items-end tw:gap-2">
        <div className="tw:flex tw:h-5 tw:w-5 tw:items-center tw:justify-center tw:rounded-[0.1875rem]">
          {renderIcon}
        </div>
        <div className="tw:text-sq-13">{item.display}</div>
      </div>
    </div>
  );
};

export const InsertSeeqContent = (item: SeeqActionDropdownItems) => {
  return (
    <div className="tw:flex tw:flex-col tw:justify-start tw:p-2.5 tw:text-left tw:font-normal tw:text-sq-text-color tw:dark:text-sq-dark-text">
      <h5
        className={clsx(
          // oxlint-disable-next-line better-tailwindcss/no-unknown-classes
          'tw:text-4',
          'tw:leading-4.5 tw:font-medium tw:text-sq-theme-dark',
        )}>
        {item.display}
      </h5>
      <div className="tw:mt-1! tw:text-sq-13 tw:text-sq-text-color tw:dark:text-sq-dark-text">{item.text}</div>
    </div>
  );
};
